import { ActivityLogRecord } from 'types/ActivityLog';
import { ActivityRecordOptions } from 'constants/activityRecord';

const { ATTRIBUTES, GROUP_TYPES } = ActivityRecordOptions;

export const formatActivityLogPostChangeMessage = (
  record: ActivityLogRecord,
) => {
  if (record.groupType === GROUP_TYPES.CREATE) {
    const changedAttributes = record.changes.map((change) => change.attribute);

    return changedAttributes.includes(ATTRIBUTES.POST_CLONE_PARENT)
      ? 'duplicated post'
      : 'created post';
  }

  return 'edited post';
};

export const getWorkflowStatusValueFromRecordChange = (
  record: ActivityLogRecord,
) => {
  return record.changes.filter(
    (change) =>
      change.attribute === ActivityRecordOptions.ATTRIBUTES.POST_STATUS,
  )[0]?.value as number | undefined;
};
